import { createContext, useContext } from "react";

const VisualEditorContext = createContext({});

export const VisualEditorContextProvider = VisualEditorContext.Provider;
export const VisualEditorContextConsumer = VisualEditorContext.Consumer;

export const useVisualEditorContext = () => useContext(VisualEditorContext);

export default VisualEditorContext;
